import { render, staticRenderFns } from "./MenuBar.vue?vue&type=template&id=3a2f629b&scoped=true"
import script from "./MenuBar.vue?vue&type=script&lang=ts"
export * from "./MenuBar.vue?vue&type=script&lang=ts"
import style0 from "./MenuBar.vue?vue&type=style&index=0&id=3a2f629b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a2f629b",
  null
  
)

export default component.exports